import React, { useState } from "react";
import { useLoginUserMutation } from "../../rtkq/services/userAuthApi";
import { storeToken } from '../../rtkq/services/localStorageService';

export const LoginForm = ({ setForgotPasswordMode, navigate }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(false);

  const [loginUser, { isLoading: isLoginLoading }] = useLoginUserMutation();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(false);

    try {
      const res = await loginUser({ email, password });

      if (res.error) {
        console.log("Login error:", res.error);
        setError(true);
      }

      if (res.data) {
        console.log("Login successful:", res.data);
        storeToken(res.data.token);
        navigate('/profile');
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <form className="space-y-6" onSubmit={handleLogin}>
      <div>
        <label 
          htmlFor="email" 
          className="block text-sm font-medium text-gray-700"
        >
          Email
        </label>
        <div className="mt-1">
          <input
            type="email"
            name="email"
            id="email"
            autoComplete="off"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 
                     focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
            placeholder="Enter your email"
          />
        </div>
      </div>

      <div>
        <label 
          htmlFor="password" 
          className="block text-sm font-medium text-gray-700"
        >
          Password
        </label>
        <div className="mt-1">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            id="password"
            autoComplete="off"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 
                     focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
            placeholder="Enter your password"
          />
        </div>
      </div>

      {error && (
        <div className="text-red-600 text-sm text-center bg-red-50 p-2 rounded-md">
          Wrong Email or Password
        </div>
      )}

      <div className="flex items-center">
        <input
          type="checkbox"
          id="showPassword"
          checked={showPassword}
          onChange={togglePasswordVisibility}
          className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded cursor-pointer"
        />
        <label 
          htmlFor="showPassword" 
          className="ml-2 block text-sm text-gray-700 cursor-pointer"
        >
          Show Password
        </label>
      </div>

      <div>
        <button
          type="submit"
          disabled={isLoginLoading}
          className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white 
                    ${isLoginLoading ? 'bg-gray-400' : 'bg-red-600 hover:bg-red-700'} 
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition duration-300`}
        >
          {isLoginLoading ? (
            <div className="flex items-center">
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Logging in...
            </div>
          ) : (
            'Login'
          )}
        </button>
      </div>

      <div className="text-right mt-2">
        <button 
          type="button" 
          onClick={() => {
            setForgotPasswordMode(true);
          }} 
          className="text-green-600 hover:text-green-500 text-sm font-medium"
        >
          Forgot Password?
        </button>
      </div>
    </form>
  );
};
